import * as classnames from "classnames";

import { JumpTo, Msg } from "..";
import Message from "../../services/message";

export function MarkdownSupport() {
  const rootStyle = classnames("code-c-markdown-support");
  return (
    <span className={rootStyle}>
      <Msg
        id="common.markdownLink"
        values={{
          Markdown: (
            <JumpTo to={Message.getMessageByKey("common.link.markdown")}>
              Markdown
            </JumpTo>
          ),
        }}
      />
    </span>
  );
}
